module.exports = __webpack_public_path__ + "img/dingdan.1f545d9a.png";